import type { Messages } from './index'

export const de: Messages = {
  action_failed: "Die Aktion ist fehlgeschlagen, bitte erneut versuchen.",
  admin_filters: "Steuerung",
  agent_approval_remove: "Agentenfreigabe entfernen",
  agent_approval_set: "An den Agenten übergeben",
  agent_blocked: "Agent: blockiert {detail}",
  agent_capacity: " · Kapazität {pct} %",
  agent_idle: "Agent: bereit, Warteschlange leer",
  agent_limited: "Agent: Nutzungslimit erreicht, weiter gegen {time}",
  agent_no_signal: "Agent: kein Lebenszeichen veröffentlicht",
  agent_route_farm: "Agentenfarm",
  agent_route_title: "Übergeben an…",
  agent_route_tower: "Kontrollturm",
  agent_stale: "Agent: keine Neuigkeiten (zuletzt um {time}), Nutzungslimit wahrscheinlich",
  agent_will_handle: "Wird vom Agenten bearbeitet",
  agent_working: "Agent: arbeitet {detail} · {queue} in der Warteschlange",
  anonymous: "Anonym",
  archive: "Archivieren",
  archive_view_active: "Aktiv",
  archive_view_all: "Alle",
  archive_view_archived: "Archiviert",
  archive_view_aria: "Archivansicht",
  archived: "Archiviert",
  business_context: "Kontext",
  cancel: "Abbrechen",
  close: "Schließen",
  comment_delete_message: "Diesen Kommentar löschen?",
  comment_delete_title: "Kommentar löschen",
  comment_mention_none: "Niemand zu erwähnen",
  comment_mention_title: "Jemanden erwähnen",
  comment_mentioned_label: "Erwähnt: {names}",
  comment_reaction: "Reaktion",
  comment_reply: "Antworten",
  comment_reply_count_one: "{count} Antwort",
  comment_reply_count_other: "{count} Antworten",
  comment_reply_hide: "Antworten ausblenden",
  comment_reply_placeholder: "Antworten… (⌘↵ zum Senden)",
  comment_voice_tooltip: "Mila, dem Sprachagenten, diktiert",
  comment_edited: "(bearbeitet)",
  comment_failed: "Der Kommentar ist fehlgeschlagen, bitte erneut versuchen.",
  comment_placeholder: "Antworten… (⌘↵ zum Senden)",
  comment_placeholder_first: "Schreibe den ersten Kommentar… (⌘↵ zum Senden)",
  comment_send: "Senden",
  comments_title: "Kommentare",
  composer_add_title: "Titel hinzufügen",
  composer_body_aria: "Beschreibung",
  composer_body_placeholder: "Details (optional) - Markdown unterstützt",
  composer_body_placeholder_feature: "Beschreibe deine Idee…",
  composer_cancel: "Abbrechen",
  composer_cancel_confirm: "Diesen Entwurf verwerfen?",
  composer_cancel_title: "Entwurf verwerfen",
  composer_cancel_yes: "Ja, verwerfen",
  composer_continue: "Weiter bearbeiten",
  composer_save: "Speichern",
  composer_saved: "Gespeichert",
  composer_saving: "Speichern…",
  composer_submit: "Feedback senden",
  composer_submit_failed: "Senden fehlgeschlagen - erneut versuchen.",
  composer_submit_sending: "Senden…",
  composer_submit_sent: "Gesendet",
  composer_title_aria: "Feedback-Titel",
  composer_title_placeholder: "Titel des Feedbacks",
  composer_title_placeholder_bug: "Was ist passiert?",
  composer_title_placeholder_feature: "Beschreibe deine Idee in einem Satz…",
  composer_title_placeholder_question: "Was ist deine Frage?",
  composer_update_failed: "Änderung fehlgeschlagen, bitte erneut versuchen.",
  confirm: "Bestätigen",
  context_capture: "Screenshot",
  context_console_errors: "Konsolenfehler ({count})",
  context_console_include: "Die letzten {count} Konsolenfehler einschließen",
  context_no_capture: "Keiner",
  context_screenshot_alt: "Screenshot",
  context_screenshot_open: "Screenshot im Vollbild öffnen",
  context_title: "Technischer Kontext",
  context_url: "URL",
  context_user_agent: "User-Agent",
  context_viewport: "Viewport",
  delete: "Löschen",
  delete_message: "Dieses Feedback löschen? Ein Administrator kann es wiederherstellen.",
  delete_title: "Feedback löschen",
  detail_discussion_label: "Diskussion",
  duplicate_of: "Duplikat von",
  edit: "Bearbeiten",
  empty_detail: "Wähle ein Feedback aus der Liste aus, um Details zu sehen.",
  empty_detail_v2: "Element auswählen",
  empty_filtered_clear: "Alle löschen",
  empty_filtered_inline: "Nichts gefunden.",
  empty_filtered_subtitle: "Filter entfernen oder Suche erweitern.",
  empty_filtered_title: "Kein Feedback passt",
  empty_first_cta: "Feedback erstellen",
  empty_first_cta_bug: "Bug",
  empty_first_cta_bug_aria: "Einen Bug melden",
  empty_first_cta_idea: "Idee",
  empty_first_cta_idea_aria: "Neue Idee erstellen",
  empty_first_cta_question: "Frage",
  empty_first_cta_question_aria: "Eine Frage stellen",
  empty_first_shortcut_hint: "Du kannst auch überall auf dieser Seite ⌘ + Umschalt + F drücken",
  empty_first_subtitle: "Ideen, Bugs oder Fragen - wir lesen alles.",
  empty_first_subtitle_v2: "Teile eine Idee, einen Bug oder eine Frage. Das Team liest jede Nachricht.",
  empty_first_title: "Teile als Erste:r dein Feedback ✨",
  empty_first_title_v2: "Starte die Unterhaltung",
  filter_all: "Alle",
  filter_all_authors: "Alle Autoren",
  filter_author: "Autor",
  filter_mine: "Nur meine Feedbacks",
  filter_others: "Von anderen",
  filter_search_aria: "Feedbacks durchsuchen",
  filter_search_clear: "Suche löschen",
  filter_search_placeholder: "Suchen (mind. 3 Zeichen)…",
  filter_status_aria: "Nach Status filtern",
  filter_trash: "Papierkorb",
  filter_type_aria: "Nach Typ filtern",
  filter_unread: "Ungelesen",
  filters_region_aria: "Filter",
  filters_reset: "Zurücksetzen",
  filters_toggle: "Filter",
  handled_by_tower: "Vom Kontrollturm übernommen",
  history_count: "{count} Änderung(en)",
  history_open: "Änderungsverlauf anzeigen",
  history_replaced_on: "Version ersetzt am {date}",
  history_title: "Änderungsverlauf",
  load_error: "Ladefehler",
  load_more: "Mehr laden",
  loading: "Lade…",
  media_add: "Medium hinzufügen",
  media_add_button: "Medium hinzufügen",
  media_attached_count: "{count} Anhang/Anhänge",
  media_close_lightbox: "Schließen",
  media_dismiss_error: "Fehler ausblenden",
  media_drop_hint: "oder per Drag & Drop",
  media_max_reached: "Maximal {max} Dateien",
  media_open_lightbox: "Vollbild öffnen",
  media_open_original: "Original öffnen",
  media_open_pdf: "PDF öffnen",
  media_remove: "Medium entfernen",
  media_too_large: "{name} überschreitet das Limit von 10 MB.",
  media_unsupported_type: "Nicht unterstützter Typ: {type}",
  media_upload_failed: "Upload fehlgeschlagen - bitte erneut versuchen.",
  media_uploading: "Lade {name} hoch…",
  modal_back: "Zurück",
  modal_close: "Schließen",
  modal_filters_active_aria: "Aktive Filter",
  modal_new: "Neu",
  modal_new_aria: "Neues Feedback",
  modal_title: "Feedbacks",
  next: "Weiter",
  not_found: "Feedback nicht gefunden",
  preview_close: "Vorschau schließen",
  preview_title: "Bereits vorhandenes Feedback",
  previous: "Zurück",
  relative_now: "gerade eben",
  retry: "Erneut versuchen",
  save: "Speichern",
  screenshot_attach: "Screenshot anhängen",
  screenshot_attached_alt: "Angehängter Screenshot",
  screenshot_capturing: "Aufnahme…",
  screenshot_failed: "Aufnahme fehlgeschlagen",
  screenshot_remove: "Screenshot entfernen",
  screenshot_target_missing: "Zielelement nicht gefunden.",
  screenshot_view: "Screenshot im Vollbild ansehen",
  search_toggle: "Suchen",
  similar_aria: "Ähnliche Feedbacks",
  similar_declined: "abgelehnt {since}",
  similar_duplicate: "Duplikat {since}",
  similar_posted: "erstellt {since}",
  similar_shipped: "ausgeliefert {since}",
  similar_title: "Existiert bereits?",
  sort_aria: "Feedback sortieren",
  sort_comments: "Meistdiskutiert",
  sort_recent: "Neueste",
  sort_score: "Stimmen",
  sort_updated: "Aktualisiert",
  source_academy: "Academy",
  source_ai: "KI",
  source_caast: "Caast-Synchronisierung",
  source_cli: "Kommandozeile",
  source_mcp: "MCP",
  source_phone: "Telefonisch diktiert",
  source_voice: "Diktiert",
  status_active: "Aktiv",
  status_change_aria: "Status: {label}, ändern",
  status_declined: "Abgelehnt",
  status_duplicate: "Duplikat",
  status_in_progress: "In Bearbeitung",
  status_on_hold: "Zurückgestellt",
  status_open: "Offen",
  status_planned: "Geplant",
  status_shipped: "Veröffentlicht",
  status_under_review: "In Prüfung",
  trigger_aria_open: "Feedbacks öffnen",
  trigger_aria_open_desktop: "Feedbacks öffnen (Tastenkürzel ⌘+Shift+F)",
  trigger_unread: "Feedback öffnen: {count} ungelesen",
  type_bug: "Bug",
  type_bug_hint: "Etwas funktioniert nicht",
  type_bugs: "Bugs",
  type_feature: "Idee",
  type_feature_hint: "Neue Funktion",
  type_features: "Ideen",
  type_legend: "Feedback-Typ",
  type_question: "Frage",
  type_question_hint: "Ich habe eine Frage",
  type_questions: "Fragen",
  unarchive: "Wiederherstellen",
  unread: "Ungelesen",
  unread_comments: "Ungelesene Kommentare",
  vote_down: "Runterstimmen",
  vote_down_remove: "Downvote entfernen",
  vote_failed: "Die Abstimmung ist fehlgeschlagen, bitte erneut versuchen.",
  vote_up: "Hochstimmen",
  vote_up_remove: "Upvote entfernen",
  typing_many: "{names} schreiben…",
  typing_one: "{name} schreibt…",
}
